var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-referral-code-wrapper",on:{"click":_setup.openReferralCodeModal}},[_c('h5',[_vm._v(_vm._s(_vm.$t('referrals.earnReferral')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }